module.exports = __webpack_public_path__ + "static/media/recruit-mock-3.5842dd78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/recruit-mock/recruit-mock-3.svg
// module id = 1775
// module chunks = 0